import { Stack, Typography } from '@mui/material';

import { VariableColumnHeader } from './VariableColumnHeader';
import type { ResultsColumnLink } from '../types';

interface PendingResultsColumnHeaderProps {
  title: string;
  caption: string;
  /** Present when the column is a variable; its name then links to the variable. */
  link?: ResultsColumnLink | null;
}

// Header of a results-grid column the processed run has no data for: the
// variable's name with a caption below it saying why the cells are empty.
export const PendingResultsColumnHeader = ({
  title,
  caption,
  link = null,
}: PendingResultsColumnHeaderProps) => (
  <Stack sx={{ minWidth: 0 }} data-testid="analysis-results-pending-column">
    {link ? (
      <VariableColumnHeader title={title} href={link.href} onOpen={link.onOpen} />
    ) : (
      <Typography variant="body2" noWrap sx={{ fontWeight: 'inherit' }}>
        {title}
      </Typography>
    )}
    <Typography variant="caption" color="text.secondary" noWrap>
      {caption}
    </Typography>
  </Stack>
);
